import React from 'react'
import { Link } from 'react-router-dom'

import UrlInput from '../components/UrlInput'

import '../styles/index.min.css'


function Homepage() {
  return (
    <div className="homepage page">
      <h1>I KILLED THIS SITE.</h1>
      <p>This was a cool little site, but I'm killing it cause it's bloat and another endpoint that I have to run on my site.</p>
      <p>I remade the same idea, at <a href="https://knife-city.com/whats-a-cookie">this url</a>, where you can view websites without cookies being applied. Obviously works on tribune/tribune articles. You can even see the sites that have been accessed using it!</p>
    </div>
  )
}


export default Homepage
